/** Language name in the display locale (`zh-cn` in French: "chinois (Chine)"); raw code if unresolvable. */
export const getLanguageDisplayName = (languageCode: string, displayLocale: string): string => {
  try {
    return new Intl.DisplayNames([displayLocale], { type: 'language' }).of(languageCode) ?? languageCode;
  } catch {
    return languageCode;
  }
};
